import { DatePickerComponent } from './date-picker.component';

export const DatePickerModule = angular
  .module('sfMobile.components.date-picker', [])
  .component('sfDatePicker', DatePickerComponent).name;
